import { Typography, Box, useTheme, Stack } from '@mui/material'
import { StatusChip } from 'components/StatusChip/StatusChip'
import { type FullCheckInPolicy } from 'types/api'

interface WelcomeBackMilestoneBonusProps {
  checkInPolicy: FullCheckInPolicy
}

export const WelcomeBackMilestoneBonusDetails = ({
  checkInPolicy,
}: WelcomeBackMilestoneBonusProps) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        border: 1,
        borderColor: theme.palette.grey[200],
        mt: '16px',
        gap: '16px',
        p: '24px',
      }}
    >
      {checkInPolicy?.enablePatronWelcomeBackMilestoneBonus ? (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: { xs: 'column' },
            gap: '16px',
          }}
        >
          <Stack spacing={3}>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
              <Typography variant="h4" marginRight={2}>
                Welcome Back Milestone Bonus
              </Typography>
              <StatusChip
                active={!!checkInPolicy?.enablePatronWelcomeBackMilestoneBonus}
                sx={{ maxWidth: '100px' }}
              />
            </Box>
          </Stack>
        </Box>
      ) : (
        <Box sx={{ flex: 1 }}>
          <Typography variant="body1" pb={1}>
            Edit to make active
          </Typography>
        </Box>
      )}
    </Box>
  )
}
